import { render, staticRenderFns } from "./OrganizationProfile.vue?vue&type=template&id=8c4c08c8&scoped=true&"
import script from "./OrganizationProfile.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4c08c8",
  null
  
)

export default component.exports